<form #tbrDialog="ngForm" autocomplete="off">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="tbr.name" maxlength="255" name="name">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ac-input-container label="Type" class="tbr-type">
    <ac-select [acModel]="tbr.type"
               (acModelChange)="tbr.type = $event; setSubmitButtonDisabled()"
               [addCustomTags]="true"
               [items]="typeOptions"
               bindLabel="text"
               bindValue="value"
               [ngDisabled]="isEditMode">
    </ac-select>
  </ac-input-container>
  <arm-form-title>Time selection</arm-form-title>
  <div class="time-selection-padding">
    <div *ngIf="tbr.type === 'DAILY'">
      <div class="daily-time-container">
        <mat-label class="utc-label">UTC</mat-label>
        <div class="time-container start">
          <ac-input-container label="Start time" class="hours">
            <ac-select [acModel]="tbr.daily.startTime.hours"
                       [searchable]="false"
                       alternativeName="daily.startTime.hours"
                       [ngDisabled]="tbr.daily.allDay"
                       (acModelChange)="tbr.daily.startTime.hours = $event; setSubmitButtonDisabled()"
                       [items]="hoursOptions">
            </ac-select>
          </ac-input-container>

          <ac-select [acModel]="tbr.daily.startTime.minutes" class="minutes"
                     [searchable]="false"
                     alternativeName="daily.startTime.minutes"
                     [ngDisabled]="tbr.daily.allDay"
                     (acModelChange)="tbr.daily.startTime.minutes = $event; setSubmitButtonDisabled()"
                     [items]="minutesOptions">
          </ac-select>
        </div>

        <div class="time-container end">
          <ac-input-container label="End time" class="hours">
            <ac-select [acModel]="tbr.daily.endTime.hours"
                       [searchable]="false"
                       alternativeName="daily.endTime.hours"
                       [ngDisabled]="tbr.daily.allDay"
                       (acModelChange)="tbr.daily.endTime.hours = $event; setSubmitButtonDisabled()"
                       [items]="hoursOptions">
            </ac-select>
          </ac-input-container>

          <ac-select [acModel]="tbr.daily.endTime.minutes" class="minutes"
                     [searchable]="false"
                     alternativeName="daily.endTime.minutes"
                     [ngDisabled]="tbr.daily.allDay"
                     (acModelChange)="tbr.daily.endTime.minutes = $event; setSubmitButtonDisabled()"
                     [items]="minutesOptions">
          </ac-select>
        </div>
        <div class="arm-checkbox">
          <mat-checkbox name="allday" color="primary" [(ngModel)]="tbr.daily.allDay" (ngModelChange)="setSubmitButtonDisabled()">All day</mat-checkbox>
        </div>
      </div>
      <div class="time-local">
        <label class="time-protocol-label">Local time</label>

        <div class="time-container start">
          <span>{{((tbr.daily.startTime.hours - timeZoneOffset/60 + 24) % 24) > 9 ? ((tbr.daily.startTime.hours - timeZoneOffset/60 + 24) % 24) : "0" + ((tbr.daily.startTime.hours - timeZoneOffset/60 + 24) % 24)}}:</span>
          <span>{{tbr.daily.startTime.minutes > 9 ? tbr.daily.startTime.minutes : "0" + tbr.daily.startTime.minutes}}</span>
        </div>

        <div class="time-container">
          <span>{{((tbr.daily.endTime.hours - timeZoneOffset/60 + 24) % 24) > 9 ? ((tbr.daily.endTime.hours - timeZoneOffset/60 + 24) % 24) : "0" + ((tbr.daily.endTime.hours - timeZoneOffset/60 + 24) % 24)}}:</span>
          <span>{{tbr.daily.endTime.minutes > 9 ? tbr.daily.endTime.minutes : "0" + tbr.daily.endTime.minutes}}</span>
        </div>
      </div>
      <mat-error *ngIf="!tbr.daily.allDay && !timeRangeIsLegal(tbr.daily.startTime, tbr.daily.endTime)">
        Start time should be before the end time
      </mat-error>
    </div>

    <div *ngIf="tbr.type === 'WEEKLY'">
      <div class="weekly-days-container">

        <div class="days-selection-container">
          <div class="btn-group">
            <button [ngClass]="{'active': tbr.selectedDay === 'MON', 'day-used': tbr.days.MON.use, 'selected-day': tbr.selectedDay === 'MON'}" type="button" (click)="chooseDay('MON')" class="btn btn-default">MON</button>
            <button [ngClass]="{'active': tbr.selectedDay === 'TUE', 'day-used': tbr.days.TUE.use, 'selected-day': tbr.selectedDay === 'TUE'}" type="button" (click)="chooseDay('TUE')" class="btn btn-default">TUE</button>
            <button [ngClass]="{'active': tbr.selectedDay === 'WED', 'day-used': tbr.days.WED.use, 'selected-day': tbr.selectedDay === 'WED'}" type="button" (click)="chooseDay('WED')" class="btn btn-default">WED</button>
            <button [ngClass]="{'active': tbr.selectedDay === 'THU', 'day-used': tbr.days.THU.use, 'selected-day': tbr.selectedDay === 'THU'}" type="button" (click)="chooseDay('THU')" class="btn btn-default">THU</button>
            <button [ngClass]="{'active': tbr.selectedDay === 'FRI', 'day-used': tbr.days.FRI.use, 'selected-day': tbr.selectedDay === 'FRI'}" type="button" (click)="chooseDay('FRI')" class="btn btn-default">FRI</button>
            <button [ngClass]="{'active': tbr.selectedDay === 'SAT', 'day-used': tbr.days.SAT.use, 'selected-day': tbr.selectedDay === 'SAT'}" type="button" (click)="chooseDay('SAT')" class="btn btn-default">SAT</button>
            <button [ngClass]="{'active': tbr.selectedDay === 'SUN', 'day-used': tbr.days.SUN.use, 'selected-day': tbr.selectedDay === 'SUN'}" type="button" (click)="chooseDay('SUN')" class="btn btn-default">SUN</button>
          </div>
        </div>
        <div class="arm-checkbox">
          <mat-checkbox name="use-day" color="primary" [(ngModel)]="tbr.days[tbr.selectedDay].use" (ngModelChange)="setSubmitButtonDisabled()">
            Enable {{tbr.days[tbr.selectedDay].fullName | titlecase}}
          </mat-checkbox>
        </div>
        <div class="daily-time-container">
          <mat-label class="utc-label">UTC</mat-label>
          <div class="time-container start">
            <ac-input-container label="Start time" class="hours">
              <ac-select [acModel]="tbr.days[tbr.selectedDay].startTime.hours"
                         [searchable]="false"
                         [ngDisabled]="tbr.days[tbr.selectedDay].allDay"
                         (acModelChange)="tbr.days[tbr.selectedDay].startTime.hours = $event; setSubmitButtonDisabled()"
                         [items]="hoursOptions">
              </ac-select>
            </ac-input-container>

            <ac-select [acModel]="tbr.days[tbr.selectedDay].startTime.minutes" class="minutes"
                       [searchable]="false"
                       alternativeName="daily.startTime.minutes"
                       [ngDisabled]="tbr.days[tbr.selectedDay].allDay"
                       (acModelChange)="tbr.days[tbr.selectedDay].startTime.minutes = $event; setSubmitButtonDisabled()"
                       [items]="minutesOptions">
            </ac-select>
          </div>

          <div class="time-container end">
            <ac-input-container label="End time" class="hours">
              <ac-select [acModel]="tbr.days[tbr.selectedDay].endTime.hours"
                         [searchable]="false"
                         alternativeName="daily.endTime.hours"
                         [ngDisabled]="tbr.days[tbr.selectedDay].allDay"
                         (acModelChange)="tbr.days[tbr.selectedDay].endTime.hours = $event; setSubmitButtonDisabled()"
                         [items]="hoursOptions">
              </ac-select>
            </ac-input-container>

            <ac-select [acModel]="tbr.days[tbr.selectedDay].endTime.minutes" class="minutes"
                       [searchable]="false"
                       alternativeName="daily.endTime.minutes"
                       [ngDisabled]="tbr.days[tbr.selectedDay].allDay"
                       (acModelChange)="tbr.days[tbr.selectedDay].endTime.minutes = $event; setSubmitButtonDisabled()"
                       [items]="minutesOptions">
            </ac-select>
          </div>
          <div class="arm-checkbox">
            <mat-checkbox name="allday" color="primary" [(ngModel)]="tbr.days[tbr.selectedDay].allDay" (ngModelChange)="setSubmitButtonDisabled()">All day</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="time-local">

        <label class="time-protocol-label">Local time</label>

        <div class="time-container start">
          <span>{{((tbr.days[tbr.selectedDay].startTime.hours - timeZoneOffset/60 + 24) % 24) > 9 ? ((tbr.days[tbr.selectedDay].startTime.hours - timeZoneOffset/60 + 24) % 24) : "0" + ((tbr.days[tbr.selectedDay].startTime.hours - timeZoneOffset/60 + 24) % 24)}}:</span>
          <span>{{tbr.days[tbr.selectedDay].startTime.minutes > 9 ? tbr.days[tbr.selectedDay].startTime.minutes : "0" + tbr.daily.startTime.minutes}}</span>
        </div>

        <div class="time-container">
          <span>{{((tbr.days[tbr.selectedDay].endTime.hours - timeZoneOffset/60 + 24) % 24) > 9 ? ((tbr.days[tbr.selectedDay].endTime.hours - timeZoneOffset/60 + 24) % 24) : "0" + ((tbr.days[tbr.selectedDay].endTime.hours - timeZoneOffset/60 + 24) % 24)}}:</span>
          <span>{{tbr.days[tbr.selectedDay].endTime.minutes > 9 ? tbr.days[tbr.selectedDay].endTime.minutes : "0" + tbr.daily.endTime.minutes}}</span>
        </div>
      </div>

      <mat-error [hidden]="tbr.days.MON.use || tbr.days.TUE.use || tbr.days.WED.use || tbr.days.WED.use || tbr.days.THU.use ||
     tbr.days.FRI.use || tbr.days.SAT.use || tbr.days.SUN.use" class="error-container">At least one day should be selected
      </mat-error>
      <mat-error [hidden]="tbr.days.MON.allDay || !tbr.days.MON.use || timeRangeIsLegal(tbr.days.MON.startTime, tbr.days.MON.endTime)">
        Monday's selected start time should be before the end time
      </mat-error>
      <mat-error [hidden]="tbr.days.TUE.allDay || !tbr.days.TUE.use || timeRangeIsLegal(tbr.days.TUE.startTime, tbr.days.TUE.endTime)">
        Tuesday's selected start time should be before the end time
      </mat-error>
      <mat-error [hidden]="tbr.days.WED.allDay || !tbr.days.WED.use || timeRangeIsLegal(tbr.days.WED.startTime, tbr.days.WED.endTime)">
        Wednesday's selected start time should be before the end time
      </mat-error>
      <mat-error [hidden]="tbr.days.THU.allDay || !tbr.days.THU.use || timeRangeIsLegal(tbr.days.THU.startTime, tbr.days.THU.endTime)">
        Thursday's selected start time should be before the end time
      </mat-error>
      <mat-error [hidden]="tbr.days.FRI.allDay || !tbr.days.FRI.use || timeRangeIsLegal(tbr.days.FRI.startTime, tbr.days.FRI.endTime)">
        Friday's selected start time should be before the end time
      </mat-error>
      <mat-error [hidden]="tbr.days.SAT.allDay || !tbr.days.SAT.use || timeRangeIsLegal(tbr.days.SAT.startTime, tbr.days.SAT.endTime)">
        Saturday's selected start time should be before the end time
      </mat-error>
      <mat-error [hidden]="tbr.days.SUN.allDay || !tbr.days.SUN.use || timeRangeIsLegal(tbr.days.SUN.startTime, tbr.days.SUN.endTime)">
        Sunday's selected start time should be before the end time
      </mat-error>
    </div>
  </div>

  <arm-form-title>Time period</arm-form-title>
  <div class="time-selection-padding">
    <div class="period-selection-container">
      <div class="arm-checkbox">
        <mat-checkbox name="use-period" color="primary" [(ngModel)]="tbr.usePeriod" (ngModelChange)="setSubmitButtonDisabled()">Enable period</mat-checkbox>
      </div>
      <div class="time-range-date-picker">
        <mat-label class="local-label">UTC</mat-label>
        <ac-date-picker [acModel]="tbr.date"
                        (acChanged)="tbr.date = $event; setSubmitButtonDisabled()"
                        startModelName="startDateTime"
                        endModelName="endDateTime"
                        openDirection="up"
                        [options]="datePickerOptions"
                        [ngDisabled]="!tbr.usePeriod">
        </ac-date-picker>
      </div>

      <div class="local" *ngIf="tbr.usePeriod">
        <mat-label class="local-label">Local time</mat-label>
        <mat-label class="local-time">{{toLocalTimeString(tbr.date.startDateTime)}} - {{toLocalTimeString(tbr.date.endDateTime)}}</mat-label>
      </div>
      <mat-error *ngIf="tbr.type === 'DAILY' && !tbr.usePeriod && (tbr.daily.allDay ||
        (tbr.daily.endTime.hours === 0 && tbr.daily.endTime.minutes === 0
          && tbr.daily.startTime.hours === 0 && tbr.daily.startTime.minutes === 0))" class="error-container">
        For all day daily selection, period must be selected
      </mat-error>
    </div>
  </div>
</form>
